import styled from "styled-components";
import { Skeleton } from "@mui/material";

export const CoachPageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    margin-bottom: 50px;
`;

export const ChannelGroup = styled.div<{ $isFirst?: boolean }>`
    display: flex;
    flex-direction: column;
    margin-top: 0;
    margin-left: -16px;
    margin-right: -16px;
`;

export const ChannelGroupHeader = styled.div<{ $isFirst?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 35px 45px 35px 35px;
    background-color: #f9f8f8;
    border-top: ${({ $isFirst }) => ($isFirst ? '1px solid #e5e0da' : 'none')};
    border-bottom: 1px solid #e5e0da;

    border-top-left-radius: ${({ $isFirst }) => ($isFirst ? '15px' : '0')};
    border-top-right-radius: ${({ $isFirst }) => ($isFirst ? '15px' : '0')};

    @media (max-width: 768px) {
        padding: 20px 25px;
    }
}
`;

export const ChannelGroupTitle = styled.span`
    font-family: 'Repro', sans-serif;
    font-size: 20px;
    font-weight: 500;
    text-transform: capitalize;
    color: black;
    line-height: 1;

    @media (max-width: 768px) {
        font-size: 16px;
    }
`;

export const MessagesFoundLabel = styled.span`
    font-family: 'Repro', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: black;
    line-height: 1;

    @media (max-width: 768px) {
        font-size: 14px;
    }
`;

export const ChannelRow = styled.div<{ $isInactive?: boolean; $isUnassigned?: boolean; $isRead?: boolean; $isAssigned?: boolean }>`
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 15px 35px 12px 25px;
    background-color: ${({ $isAssigned, $isRead }) => $isAssigned ? 'rgba(0,128,128,.16)' : $isRead ? 'rgba(53,90,221,.04)' : '#faf9f7'};
    border-bottom: 1px solid #ece9e4;
    cursor: ${({ $isUnassigned }) => ($isUnassigned ? 'default' : 'pointer')};
    pointer-events: auto;

    @media (max-width: 768px) {
        padding: 15px 25px 12px 25px;    
    }
`;

export const ChannelRowContent = styled.div<{ $isInactive?: boolean; $alignStart?: boolean; $state?: string }>`
    display: flex;
    align-items: center;
    gap: 40px;
    flex: 1;
    min-width: 0;
    opacity: 1;

    @media (max-width: 420px) {
        ${({ $state }) => $state === 'unassigned' && 'gap: 15px;'}
    }
    
`;

export const ChannelInactiveLabel = styled.div`
    content: "Not Active";
    position: absolute;
    bottom: 15px;
    left: 105px;
    background: url(https://members.performancegolf.com/wp-content/themes/pgm/dist/images/icons/exclamation.svg) no-repeat 0;
    background-size: contain;
    padding-left: 25px;
    opacity: 1 !important;
    color: #1D1A1A;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    font-family: Repro, sans-serif;
    pointer-events: none;

    @media (max-width: 768px) {
        font-size: 12px;
        line-height: 16px;
        left: 75px;
    }
`;

export const ChannelAvatarWrapper = styled.div`
    position: relative;
    flex-shrink: 0;
`;

export const ChannelAvatar = styled.div<{ $color?: string }>`
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background-color: ${({ $color }) => $color ?? '#2e2a28'};
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Repro', sans-serif;
    font-size: 14px;
    font-weight: 600;
    color: #fff;
    text-transform: uppercase;
    overflow: hidden;
`;

export const ChannelAvatarImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

export const ChannelDot = styled.div<{ $variant: 'red' | 'yellow' | 'black' | 'blue' | 'teal' }>`
    position: absolute;
    top: -3px;
    right: 0px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background-color: ${({ $variant }) =>
        $variant === 'red'    ? '#ef4444' :
        $variant === 'yellow' ? '#e67700' :
        $variant === 'black'  ? '#2e2a28' :
        $variant === 'teal'   ? '#33c6bd' :
        '#3b82f6'
    };
`;

export const ChannelInfo = styled.div`
    flex: 1;
    min-width: 0;
`;

export const ChannelNameRow = styled.div<{ $hasBadges?: boolean }>`
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;

    @media (max-width: 768px) {
        ${({ $hasBadges }) => $hasBadges && `
            flex-direction: column;
            align-items: flex-start;
        `}
    }
`;

export const ChannelName = styled.div`
    font-family: 'Repro', sans-serif;
    font-size: 18px;
    font-weight: 600;
    color: #1d1a1a;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;

    @media (max-width: 768px) {
        font-size: 15px;
    }
`;

export const ChannelLastMessage = styled.div`
    font-family: 'Repro', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #868585;
    margin-top: 6px;
    line-height: 1;

    @media (max-width: 768px) {
        font-size: 14px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;

export const ChannelMeta = styled.div<{ $isOverdue?: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    flex-shrink: 0;
    gap: 4px;
`;

export const ChannelDate = styled.div<{ $isOverdue?: boolean }>`
    font-family: 'Repro', sans-serif;
    font-size: 15px;
    font-weight: 400;
    color: ${({ $isOverdue }) => ($isOverdue ? '#dd4835' : 'black')};
    text-align: right;
    line-height: 1.15;

    @media (max-width: 768px) {
        font-size: 12px;
        line-height: 12px;
    }
`;

export const ChannelStatus = styled.div<{ $variant: 'overdue' | 'respond_soon' | 'sent' }>`
    font-family: 'Repro', sans-serif;
    font-size: 15px;
    line-height: 1;
    color: ${({ $variant }) =>
        $variant === 'overdue'      ? '#dd4835' :
        $variant === 'respond_soon' ? '#e67700' :
        '#3b82f6'
    };

    @media (max-width: 768px) {
        font-size: 12px;
    }
`;

export const FilterWrapper = styled.div`
    display: flex;
    gap: 50px;
    margin-bottom: 20px;
    
    @media (max-width: 768px) {
        gap: clamp(8px, 7vw, 27px);
    }

    @media (min-width: 769px) {
        padding: 0 15px;
    }
`;

export const SearchWrapper = styled.div`
    position: relative;
    width: 70%;
    margin-bottom: 16px;
    border: 2px solid transparent;
    border-radius: 25px;
    margin-bottom: 40px;

    &:focus-within {
        border: 2px solid black;
        border-radius: 25px;
    }

    @media (max-width: 768px) {
        width: 100%;
        margin-bottom: 20px;
    }
`;

export const SearchInput = styled.input`
    color: #868585;
    font-size: 12px;
    font-weight: 400;
    line-height: 1;
    border-radius: 25px;
    background: #f9f8f8;
    padding: 13px 49px 13px 20px;
    border: 0;
    display: block;
    width: 100%;
    font-family: Roboto, sans-serif;
    outline: none;
    box-sizing: border-box;
`;

export const SearchIconWrapper = styled.div`
    position: absolute;
    top: 50%;
    right: 15px;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    pointer-events: none;

    svg {
        width: 19px;
        height: 19px;
    }
`;

export const FilterButton = styled.button<{ $isUnasigned?: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;

    ${({ $isUnasigned }) => $isUnasigned && `
        position: absolute;
        top: 25px;
        right: 40px;
        margin-right: 0 !important;
    `}
`;

export const FilterCircle = styled.div<{ $isActive?: boolean, $filterColor: string }>`
    position: relative;
    width: 70px;
    height: 70px;
    border-radius: 50%;
    background-color: #f9f8f8;
    border: 2px solid ${({ $isActive, $filterColor }) => ($isActive ? $filterColor : '#f9f8f8')};
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: 768px) {
        width: 43px;
        height: 43px;
    }
`;

export const FilterIcon = styled.div`
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        width: 100%;
        height: 100%;
    }

    @media (max-width: 768px) {
        width: 24px;
        height: 24px;
    }
`;

export const FilterIndicatorBadge = styled.div<{ $color: string }>`
    position: absolute;
    top: -5px;
    right: -7px;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background-color: ${({ $color }) => $color};
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 700;
    color: #fff;
    line-height: 1;

    @media (max-width: 768px) {
        width: 17px;
        height: 17px;
        top: -4px;
        right: -5px;
        font-size: 8px;
    }
`;

export const FilterLabel = styled.span`
    color: #0a0a0a;
    font-size: 14px;
    line-height: 1;
    text-align: center;
    margin-top: 5px;
    font-family: Roboto, sans-serif;
    font-weight: 400;

    @media (max-width: 768px) {
        font-size: 12px;
        white-space: normal;
        overflow-wrap: normal;
        max-width: 48px;
    }
`;

export const FlagBadgesWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
`;

export const FlagBadge = styled.span<{ $flag: string }>`
    font-family: 'Repro', sans-serif;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    padding: 2px 6px;
    border-radius: 4px;
    white-space: nowrap;
    background-color: ${({ $flag }) => {
        switch ($flag) {
            case 'vip_experience': return '#FFF173';
            case 'vip_elite': return '#355add';
            default: return '#7b726c';
        }
    }};
    color: ${({ $flag }) => $flag === 'vip_experience' ? '#1d1a1a' : '#fff'};
`;

export const AssignToMeButton = styled.button<{ $disabled?: boolean; $hasBadges?: boolean; $longName?: boolean }>`
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    padding: 6px 10px;
    border-radius: 4px;
    border: 2px solid #1d1a1a;
    text-decoration: none;
    font-family: Repro, sans-serif;
    background: #faf9f7;
    color: #1d1a1a;
    cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
    opacity: ${({ $disabled }) => ($disabled ? 0.4 : 1)};
    pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
    white-space: nowrap;
    &:hover {
        background-color: #1d1a1a;
        color: #fff;
    }

    @media (max-width: 380px) {
        ${({ $hasBadges }) => $hasBadges && 'font-size: 14px;'}
    }

`;

// ─── Skeleton components ──────────────────────────────────────────────────────

export const SkeletonSearchBar = styled(Skeleton)({
    height: '46px',
    width: '70%',
    borderRadius: '25px !important',
    transform: 'none',
    marginBottom: '40px',
    '@media (max-width: 768px)': {
        width: '100%',
        marginBottom: '20px',
    },
});

export const SkeletonFilterItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const SkeletonFilterCircle = styled(Skeleton)({
    width: '70px',
    height: '70px',
    borderRadius: '50% !important',
    transform: 'none',
    flexShrink: 0,
    '@media (max-width: 768px)': {
        width: '43px',
        height: '43px',
    },
});

export const SkeletonFilterLabel = styled(Skeleton)({
    width: '40px',
    height: '12px',
    borderRadius: '4px !important',
    transform: 'none',
    marginTop: '5px',
});

export const SkeletonChannelRow = styled.div`
    display: flex;
    align-items: center;
    gap: 40px;
    padding: 15px 35px 12px 25px;
    border-bottom: 1px solid #ece9e4;

    @media (max-width: 768px) {
        gap: 20px;
        padding: 15px 25px 12px 25px;
    }
`;

export const SkeletonAvatar = styled(Skeleton)({
    width: '42px',
    height: '42px',
    borderRadius: '50% !important',
    transform: 'none',
    flexShrink: 0,
});

export const SkeletonChannelInfo = styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const SkeletonBar = styled(Skeleton)<{ $w?: string; $h?: string }>(({ $w, $h }) => ({
    width: $w ?? '100%',
    height: $h ?? '16px',
    borderRadius: '4px !important',
    transform: 'none',
}));

export const SkeletonMetaBlock = styled(Skeleton)({
    width: '80px',
    height: '18px',
    borderRadius: '4px !important',
    transform: 'none',
    flexShrink: 0,
    '@media (max-width: 768px)': {
        width: '60px',
    },
});

export const OverdueAlert = styled.div<{ $visible: boolean }>`
    display: ${({ $visible }) => ($visible ? 'flex' : 'none')};
    align-items: center;
    gap: 10px;
    padding: 12px 20px;
    margin-top: 16px;
    margin-bottom: 35px;
    border: 1px solid #dd4835;
    border-radius: 4px;
    background-color: #fff;
    font-family: 'Lato', sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 140%;
    color: #18181b;

    svg {
        flex-shrink: 0;
        color: #dd4835;
    }
`;

export const EmptyChannelsPlaceholder = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f9f8f8;
    border-radius: 15px;
    overflow: hidden;
    height: 100%;
    margin-left: -16px;
    margin-right: -16px;
    min-height: 450px;

    @media (max-width: 768px) {
        margin-left: -15px;
        margin-right: -15px;
    }
`;

export const EmptyChannelsText = styled.span`
    font-family: 'Repro', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    color: #000;
`;

